import { BigMath } from "@yn/utils";
import type { BigValueType } from "@yn/utils";

export type { BigValueType };
export default BigMath;
